import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { IExternalEntity, IExternalEntityCriteria } from 'src/app/masters/peoples/external-entity/external-entity.interface';
import { IDestination } from 'src/app/masters/places/destination/destination.interface';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { KEYS } from 'src/app/shared/constants/keys';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IDestinationCriteria, IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { IConsortium, IConsortiumCriteria, IConsortiumDestination } from '../../consortium/consortium.interface';
import { ILinerServiceCriteria } from '../../liner-service/liner-service.interface';
import { IOriginServicesForm } from '../liner-origin-service.interface';

@Component({
    selector: 'app-liner-origin-service-form',
    templateUrl: './liner-origin-service-form.component.html',
    styleUrls: ['./liner-origin-service-form.component.less'],
    standalone: false
})
export class LinerOriginServiceFormComponent implements OnInit,OnDestroy {
  dailogRef: any;

  constructor(private formBuilder:FormBuilder, private activated:ActivatedRoute,
              private router:Router, private utilityService:UtilityService,
              private service:DataService, private permissionService:PermissionService,
              private logger:NGXLogger,private activatedRoute:ActivatedRoute,
              private dailog:MatDialog) { }

  originServiceForm:FormGroup;
  modes:any;
  originList:any;
  destinationCriteria:IDestinationCriteria={};
  addPermission:boolean=false;
  editPermission:boolean=false;
  deactivatePermission:boolean=false;
  reactivatePermission:boolean=false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  filteredLines:ReplaySubject<IExternalEntity[]> = new ReplaySubject<IExternalEntity[]>(1);
  filteredDestinations:ReplaySubject<IDestination[]> = new ReplaySubject<IDestination[]>(1);
  filteredConsortium:ReplaySubject<IConsortium[]> = new ReplaySubject<IConsortium[]>(1);
  filteredConsortiumDest:ReplaySubject<IConsortiumDestination[]> = new ReplaySubject<IConsortiumDestination[]>(1);
  lineSearchCtrl=this.formBuilder.control('');
  destinationSearchCtrl=this.formBuilder.control('');
  consortiumSearchCtrl=this.formBuilder.control('');
  polSearchCtrl=this.formBuilder.control('');
  originFormData:any;
  @Input() searching: boolean = false;
  onDestroy=new Subject<void>();
  lines:any;
  consortiums:any;
  consortiumDestinations:any;
  disableSubmit:boolean=false;
  consortiumCriteria:IConsortiumCriteria={};
  countryId:number;
  destinations:any;
  linerServiceCriteria:ILinerServiceCriteria={};
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  showStatus:string;
  isEditedData:boolean=false;
  checkedToggle:boolean=false;
  viewLog = this.formBuilder.control(false);

  ngOnInit(): void {
    this.viewLog.setValue(false);
    this.getCountryByCompanyId();
    this.getAllPermissions();
    this.initializeForm();
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id'])
          this.id.setValue(+param['id']);
    });
    this.getModeList();
    this.getOriginList();
    this.getDestinationList();
    this.getLineList();
    this.filterLines();
    this.filterDestinations();
    this.filterConsortium();
    this.filterConsortiumDestination();
    this.setOriginValueChangeEvent();
    this.setLineValueChangeEvent();
    this.setConsortiumValueChangeEvent();
    this.setPolValueChangeEvent();
    this.getLinerOriginById();
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  initializeForm(){
    this.originServiceForm=this.formBuilder.group({
      id:[],
      originId:[null,[Validators.required]],
      status:[],
      activeFlag:[],
      parentId:[],
      originType:[null],
      lineId:[null,[Validators.required]],
      consortiumId:[null,[Validators.required]],
      polId:[null,[Validators.required]],
      mode:[null,[Validators.required]],
      transitTime:[null,[Validators.required,Validators.pattern('^[1-9]+[0-9]*$')]],
      linerOriginServiceDetails:this.formBuilder.array([this.consortiumOrLinerServiceDetailForm()])
    })
  }

  private consortiumOrLinerServiceDetailForm(data?:any){
    return this.formBuilder.group({
      id:[data?data.id:null],
      sequenceNo:[data?data.sequenceNo:null],
      portId:[data?data.portId:null,[Validators.required]],
      destinationId:[data?data.destinationId:null,[Validators.required]],
      mode:[data?data.mode:null,[Validators.required]],
      transitTime:[data?data.transitTime:null,[Validators.required]],
      identifier:[data?data.identifier:null],
      transhipmentPorts:this.formBuilder.array([]),
      deactivated:[data?data.deactivated:true]
    });
  }

  private transhipmentPortForm(data?:any){
     return this.formBuilder.group({
       transhipmentPortId:[data?data.transhipmentPortId:null],
       transhipmentPortName:[data?data.transhipmentPortName:null],
     })
  }

  setConsortiumValueChangeEvent(){
    this.consortiumId.valueChanges.subscribe(consortiumValue => {
      this.polId.reset();
      this.linerOriginServiceDetails.clear();
      let consortium=_.findWhere(this.consortiums,{id:consortiumValue});
      if(consortium){
        this.consortiumDestinations=consortium.destinationDetails;
        this.filteredConsortiumDest.next(this.consortiumDestinations);
      }
    })
  }

  setPolValueChangeEvent(){
    this.polId.valueChanges.subscribe(polValue => {
      this.linerOriginServiceDetails.clear();
      if(this.polId.value && this.lineId.value && this.consortiumId.value){
        this.logger.info('Value Of field',this.polId.value,this.lineId.value,this.consortiumId.value);
        this.setServiceValueFromConsortium(polValue);
        this.getLinerServiceList();
      }
    })
  }

  setAllServicesAsDeactivated(){
    if(!this.id.value)
    this.linerOriginServiceDetails.controls.forEach(element => {
      element.get('deactivated').setValue(true);
    });
  }

  private setServiceValueFromConsortium(polValue: any) {
      let consortium = _.findWhere(this.consortiums, { parentId: this.consortiumId.value });
      this.logger.info('Consortium Id');
      if (consortium) {
        let services = _.where(consortium.consortiumServiceDetails, { portId: polValue });
        this.logger.info('Services',services);
        services.forEach((element, index) => {
          if(!element.deactivated){
            element.identifier='consortium_service_'+element.code;
            if(_.findWhere(this.originFormData?.linerOriginServiceDetails,{identifier:element.identifier})){
              return;
            }
            this.logger.info('Patch Service Value to form');
            element.sequenceNo = this.linerOriginServiceDetails.length + 1;
            this.linerOriginServiceDetails.push(this.consortiumOrLinerServiceDetailForm(element));
            this.getTranshipmentPortArray(this.linerOriginServiceDetails.length-1).clear();
            this.getTranshipmentPortArray(this.linerOriginServiceDetails.length-1).push(this.transhipmentPortForm({transhipmentPortId:0,transhipmentPortName: 'Direct'}));
            this.logger.info('Patch Service Value to form',this.linerOriginServiceDetails.value);
          }
        });
        this.setAllServicesAsDeactivated();
      }
  }

  private getTranshipmentPortArray(index:number) {
    return (<FormArray>this.linerOriginServiceDetails.at(index).get('transhipmentPorts'));
  }

  getLinerServiceList(){
      this.setLinerServiceCriteria();
      this.service.get(Api.LINER_SERVICE_FOR_DD,this.linerServiceCriteria).subscribe(res => {
        this.logger.info('Liner Service By Criteria Res',res);
        let data:IOriginServicesForm={};
        if(res){
          res.forEach((element, index) => {
            data.identifier='liner_service_'+element.parentId;
            if(_.findWhere(this.originFormData?.linerOriginServiceDetails,{identifier:data.identifier})){
              return;
            }
            if(element.status !=='DEACTIVATED'){
              data.transitTime = element.transitTime;
              this.prepareDataAndSetValueToServiceForm(data, element);
            }
          });
          this.setAllServicesAsDeactivated();
        }
      })
  }

  private prepareDataAndSetValueToServiceForm(data: IOriginServicesForm, element: any) {
    data.sequenceNo = this.linerOriginServiceDetails.length + 1;
    data.deactivated = element.status == 'DEACTIVATED' ? true : false;
    data.transhipmentPort = '';
    let transhipmentPorts = [];
    element.linerServiceDetails.forEach(obj => {
      if (obj.sequenceNo == 1) {
        data.portId = obj.portId;
        data.mode = obj.mode;
      }
      if (obj.sequenceNo == element.linerServiceDetails.length) {
        data.destinationId = obj.destinationId;
      } else {
        let destination=_.findWhere(this.destinations,{id:obj.destinationId});
        transhipmentPorts.push({ transhipmentPortId: obj.destinationId, transhipmentPortName: destination.name });
      }
    });
    this.linerOriginServiceDetails.push(this.consortiumOrLinerServiceDetailForm(data));
    this.getTranshipmentPortArray(data.sequenceNo - 1).clear();
    transhipmentPorts.forEach(item => {
      this.getTranshipmentPortArray(data.sequenceNo - 1).push(this.transhipmentPortForm(item));
    });
  }

  private setLinerServiceCriteria() {
    this.linerServiceCriteria['consortiumId.equals'] = this.consortiumId.value;
    this.linerServiceCriteria['polId.equals'] = this.polId.value;
    this.linerServiceCriteria['lineId.equals'] = this.lineId.value;
    this.linerServiceCriteria['activeFlag.equals'] = true;
  }

  setOriginValueChangeEvent(){
    this.originId.valueChanges.subscribe(originValue => {
       let destination=_.findWhere(this.originList,{id:originValue});
       if(destination){
        this.originType.setValue(destination.type);
       }
    })
  }

  setLineValueChangeEvent(){
    this.lineId.valueChanges.subscribe(lineValue => {
       this.resetFormField();
       this.consortiumCriteria.lineId=lineValue;
       this.consortiumCriteria['activeFlag.equals']=true;
       this.getConsortiumList();
    })
  }

  private resetFormField() {
    this.polId.reset();
    this.consortiumId.reset();
    this.linerOriginServiceDetails.clear();
  }

  filterLines() {
    this.lineSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.lines) { return []; }
          if(!search) { this.filteredLines.next(this.lines); }
          return this.lines.filter(line => (line.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
          || (line.code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredLines => {
        this.searching = false;
        this.filteredLines.next(filteredLines);
      },
      error => { this.searching = false; });
  }

  filterConsortium() {
    this.consortiumSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.consortiums) { return []; }
          if(!search) { this.filteredConsortium.next(this.consortiums); }
          return this.consortiums.filter(consortium => (consortium.name.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredConsortium => {
        this.searching = false;
        this.filteredConsortium.next(filteredConsortium);
      },
      error => { this.searching = false; });
  }

  filterConsortiumDestination() {
    this.polSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.consortiumDestinations) { return []; }
          if(!search) { this.filteredConsortiumDest.next(this.consortiumDestinations); }
          return this.consortiumDestinations.filter(consortiumDest => (consortiumDest.destinationName.toLowerCase().indexOf(search.toLowerCase()) > -1)
          || (consortiumDest.destinationCode.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredConsortiumDest => {
        this.searching = false;
        this.filteredConsortiumDest.next(filteredConsortiumDest);
      },
      error => { this.searching = false; });
  }

  filterDestinations() {
    this.destinationSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          this.logger.info('Destination Search Value',search);
          if (!this.originList) { return []; }
          if(!search) { this.filteredDestinations.next(this.originList); }
          return this.originList.filter(destination => (destination.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
          || (destination.code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredDestination => {
        this.searching = false;
        this.filteredDestinations.next(filteredDestination);
      },
      error => { this.searching = false; });
  }

  checkToggleAlert(){
    const temp = this.linerOriginServiceDetails.value.filter(item => item.deactivated == false);
    this.checkedToggle = temp.length >= 1;

  }

  onSave(){
    this.checkToggleAlert();
    if(!this.checkedToggle){
      this.utilityService.notifier('Activate atleast anyone Liner/Consortium Service','info');
      return;
    }
    this.originServiceForm.markAllAsTouched();
    if(this.originServiceForm.valid)
    {
      this.isEditedData=true;
       if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
         }
       else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
       }  
    }
  }

  saveLinerOriginServiceModule(){
    this.logger.info('LinerOriginService Form Value before validation',this.originServiceForm.getRawValue());
    this.originServiceForm.markAllAsTouched();
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.originServiceForm.valid)
    {
      this.originServiceForm.markAsUntouched();
      this.service[method](Api.LINER_ORIGIN,this.originServiceForm.getRawValue()).subscribe(res => {
        this.utilityService.notifier('Liner Origin Service Details '+message+' successfully', 'success');
        this.router.navigate([APP_ROUTES.LINER_ORIGIN_SERVICE]);
      });
    }
  }

  onCancel()
  {
    if(this.originServiceForm.dirty){
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
    this.router.navigate([APP_ROUTES.LINER_ORIGIN_SERVICE]);
    }
  }

private openDailog(message?:string){
  const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

  dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult===false){
        return;
      }
      else {
        if(!this.isEditedData) {
          this.router.navigate([APP_ROUTES.LINER_ORIGIN_SERVICE]);
        }
        else {
         this.saveLinerOriginServiceModule();
        }
      }
  })
}
 

  openDeactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.LINER_ORIGIN_SERVICE,message:'Liner Origin Service',api:Api.LINER_ORIGIN_DEACTIVATE}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }

  openReactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.LINER_ORIGIN_SERVICE,message:'Liner Origin Service',api:Api.LINER_ORIGIN_REACTIVATE}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }

  private getLinerOriginById(){
    if(this.id.value){
      this.service.get(Api.LINER_ORIGIN+'/'+this.id.value).subscribe(res => {
        this.logger.info('Liner Origin Service By Id',res);
        this.showStatus=this.getStatus(res);
        if(res.submittedForApproval || res.status==='DEACTIVATED' || !this.editPermission){
          this.originServiceForm.disable();
          this.disableSubmit=true;
        }
        this.originFormData=res;
        this.originServiceForm.patchValue(res);
        this.patchServiceDetails(res);
    });
  }
}

  private patchServiceDetails(res:any){
    res.linerOriginServiceDetails.forEach(obj => {
      let form=this.consortiumOrLinerServiceDetailForm(obj);
      this.linerOriginServiceDetails.push(form);
      this.setTranshipmentPortDetails(obj,form);
    });
  }

  private setTranshipmentPortDetails(obj: any,form:FormGroup) {
    obj.transhipmentPorts.forEach(port => {
      if(!port.transhipmentPortId){
        port.transhipmentPortName='Direct';
      } else {
        let destination=_.findWhere(this.originList,{id:port.transhipmentPortId});
        port.transhipmentPortName=destination?.name;
      }
      // this.getTranshipmentPortArray(this.linerOriginServiceDetails.length - 1).push(this.transhipmentPortForm(port));
      (<FormArray>form.get('transhipmentPorts')).push(this.transhipmentPortForm(port));
    });
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  getLineList(){
    let lineCriteria:IExternalEntityCriteria={};
    lineCriteria.activeFlag=true;
    this.service.get(Api.EXTERNAL_ENTITY_FOR_DD).subscribe(res => {
      if(res){
        this.lines=res;
        this.filteredLines.next(this.lines);
      }
    })
  }

  getConsortiumList(){
    this.service.get(Api.CONSORTIUM_FOR_DD,this.consortiumCriteria).subscribe(res => {
      if(res){
        this.consortiums=res;
        this.filteredConsortium.next(this.consortiums);
        if(this.consortiumId.value){
          let consortium=_.findWhere(this.consortiums,{id:this.consortiumId.value});
          if(consortium){
            this.consortiumDestinations=consortium.destinationDetails;
            this.filteredConsortiumDest.next(this.consortiumDestinations);
          }
        }
        if(this.polId.value){
          this.setServiceValueFromConsortium(this.polId.value);
        }
      }
    })
  }

  getModeList(){
    this.service.get(Api.MODE_LIST).subscribe(res => {
      if(res){
        this.modes=res;
      }
    })
  }

  getOriginList(){
    this.destinationCriteria.countryId=null;
    this.destinationCriteria.types=['ISD_INLAND_CONTAINER_DEPOT','DESTINATION','CITY'];
    // this.destinationCriteria.countryId=this.countryId;
    this.service.get(Api.DESTINATION_FOR_DD,this.destinationCriteria).subscribe(res => {
      if(res){
        this.originList=res;
        this.filteredDestinations.next(this.originList);
      }
    })
  }

  getDestinationList(){
    this.service.get(Api.DESTINATION_FOR_DD).subscribe(res => {
      if(res){
        this.destinations=res;
      }
    })
  }

  getCountryByCompanyId(){
    let companyId=+localStorage.getItem(KEYS.COMPANY_ID);
     if(companyId){
      this.service.get(Api.COUNTRY_BY_COMPANY_ID+'/'+companyId).subscribe(res => {
         this.logger.info('Country Id By Company Id',res);
         this.countryId=res;
         this.getOriginList();
      });
     }
  }

  getSaveBtnCondition(){
    if(this.disableSubmit || (!this.editPermission && this.id.value) || (!this.addPermission && !this.id.value) || !this.originServiceForm.dirty){
      return false;
    }
    return true;
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.LINER_ORIGIN_SERVICE_MODULE_EDIT_PERMISSION,PermissionKey.LINER_ORIGIN_SERVICE_MODULE_REACTIVATE_PERMISSION,
                PermissionKey.LINER_ORIGIN_SERVICE_MODULE_DEACTIVATE_PERMISSION,PermissionKey.LINER_ORIGIN_SERVICE_MODULE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.LINER_ORIGIN_SERVICE_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_ORIGIN_SERVICE_MODULE_ADD_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_ORIGIN_SERVICE_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_ORIGIN_SERVICE_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_ORIGIN_SERVICE_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
  }

  get id(){ return this.originServiceForm.get('id'); }
  get originId(){ return this.originServiceForm.get('originId'); }
  get originType(){ return this.originServiceForm.get('originType'); }
  get lineId(){ return this.originServiceForm.get('lineId'); }
  get consortiumId(){ return this.originServiceForm.get('consortiumId'); }
  get polId(){ return this.originServiceForm.get('polId'); }
  get mode(){ return this.originServiceForm.get('mode'); }
  get transitTime(){ return this.originServiceForm.get('transitTime'); }
  get linerOriginServiceDetails(){ return (<FormArray>this.originServiceForm.get('linerOriginServiceDetails')); }
}
